/* eslint-disable react-hooks/rules-of-hooks */
import { useContext } from 'react'
import { UserContext } from '../context/userContext'

export const userData = () => useContext(UserContext)
